/* tslint:disable */
/* eslint-disable */
export enum EventOrderByEnum {
  Id = 'Id',
  CreatedUtc = 'CreatedUtc',
  EventType = 'EventType'
}
